// extracted by css-extract-rspack-plugin
export default {"dashWrapper":"r75_IFVq"};